import { Component, Input, OnInit } from '@angular/core';
import { LinkConfig } from '@zipari/shared-ds-util-navigation';
import { TileGridCard } from './tile-grid.model';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'tile-grid',
  templateUrl: './tile-grid.component.html',
  styleUrls: ['./tile-grid.component.scss'],
})
export class TileGridComponent implements OnInit {
  @Input() tiles: TileGridCard[];
  // eslint-disable-next-line no-magic-numbers
  @Input() columns = 3;
  @Input() externalSiteModalConfig;

  iconColor: string;

  ngOnInit(): void {
    const [tiles, externalSiteModalConfig] = checkInputsForText([
      this.tiles,
      this.externalSiteModalConfig,
    ]);

    this.tiles = tiles;
    this.externalSiteModalConfig = externalSiteModalConfig;
  }

  get gridTemplateColumns() {
    return `repeat(${this.columns}, 1fr)`;
  }

  getIconColor(tile: TileGridCard) {
    return tile.icon_color
      ? tile.icon_color.replace('var(--', '').replace(')', '')
      : '--icon-color';
  }

  getIconConfiguration(tile: TileGridCard) {
    const iconColor = this.getIconColor(tile);

    return {
      size: tile.icon_size || 'large',
      fill: iconColor,
    };
  }

  getLinkConfig(tile: TileGridCard): LinkConfig {
    return {
      label: tile.title,
      externalLink: tile.isExternalRoute ? tile.route : null,
      route: !tile.isExternalRoute ? tile.route : null,
      useExternalSiteModal: tile.useExternalSiteModal,
      target: tile.target,
    };
  }
}
